import queryString from "query-string";
export const shouldShowDecoupling = () => true;
export const shouldShowDiscrete = () => hasQueryParam(discreteFeatureFlag);

const hasQueryParam = flag => {
  return queryString.parse(window.location.search)?.[flag] === "1";
};

const decouplingFeatureFlag = "decoupling";
const discreteFeatureFlag = "discrete";
